import { useHistoryContext } from 'hooks/useHistoryContext';
import { useNavigateToRoot } from 'hooks/useNavigateToRoot';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link } from 'react-router-dom';
import { ButtonProps, Button } from 'shared/mui/Buttons';

export type CancelButtonProps = ButtonProps & { linkType?: 'back' | 'exit' };

export const CancelButton: React.FC<CancelButtonProps> = ({
  label,
  linkType = 'exit',
  variant = 'text',
  size = 'medium',
  onClick,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const { baseRoute } = useHistoryContext();
  const { toRoot } = useNavigateToRoot();

  return linkType === 'back' && !!baseRoute ? (
    <Button
      component={Link}
      label={label || translate('app.buttons.cancel')}
      size={size}
      variant={variant}
      {...restProps}
      {...(onClick ? { onClick } : { to: baseRoute })}
    />
  ) : (
    <Button
      label={label || translate('app.buttons.cancel')}
      onClick={onClick || toRoot}
      size={size}
      variant={variant}
      {...restProps}
    />
  );
};
